import { Plus, FileText, Mail, MessageCircle, Layers, Send, MailOpen, MousePointerClick, LineChart } from "lucide-react";
import { BarChart, Bar, ResponsiveContainer, XAxis, Tooltip } from "recharts";
import { AppChrome } from "./DashboardMockup";

const metrics = [
    { icon: Send, label: "Sent", value: "2,450" },
    { icon: MailOpen, label: "Opened", value: "1,782" },
    { icon: MousePointerClick, label: "Clicked", value: "532" },
    { icon: LineChart, label: "Open Rate", value: "72.7%" },
];

const weekly = [
    { d: "Mon", v: 290 }, { d: "Tue", v: 315 }, { d: "Wed", v: 268 },
    { d: "Thu", v: 352 }, { d: "Fri", v: 301 }, { d: "Sat", v: 146 }, { d: "Sun", v: 110 },
];

const campaigns = [
    { name: "Monsoon Offer — July", channel: "Email + WhatsApp", icon: Mail, sent: "1,240", rate: "74.2%", status: "Running" },
    { name: "Site Visit Reminders", channel: "WhatsApp", icon: MessageCircle, sent: "486", rate: "91.5%", status: "Running" },
    { name: "Welcome Sequence", channel: "Sequence · 4 steps", icon: Layers, sent: "724", rate: "63.8%", status: "Active" },
];

const EngageScreen = () => (
    <div>
        <AppChrome active="Engage" />
        <div className="bg-[#F7F9FA] p-3.5 sm:p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                    <p className="font-display text-[15px] font-extrabold text-[#111827]">Engage</p>
                    <p className="text-[10px] text-[#64748B]">Campaigns, sequences and templates — powered by CRM data</p>
                </div>
                <div className="flex items-center gap-1.5">
                    <span className="hidden items-center gap-1 rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[9px] font-semibold text-[#475569] sm:flex">
                        <FileText className="h-2.5 w-2.5" /> Templates
                    </span>
                    <span className="flex items-center gap-1 rounded-lg bg-[#16A34A] px-2 py-1 text-[9px] font-bold text-white">
                        <Plus className="h-2.5 w-2.5" /> New Campaign
                    </span>
                </div>
            </div>

            <div className="mt-2.5 grid grid-cols-2 gap-2 lg:grid-cols-4">
                {metrics.map((m) => (
                    <div key={m.label} className="rounded-xl border border-[#EDF0F3] bg-white p-2.5 shadow-sm">
                        <m.icon className="h-3 w-3 text-[#16A34A]" />
                        <p className="mt-1.5 font-display text-[15px] font-extrabold leading-none text-[#111827]">{m.value}</p>
                        <p className="mt-1 text-[8px] font-bold uppercase tracking-[0.08em] text-[#94A3B8]">{m.label}</p>
                    </div>
                ))}
            </div>

            <div className="mt-2 grid gap-2 lg:grid-cols-5">
                <div className="rounded-xl border border-[#EDF0F3] bg-white p-3 shadow-sm lg:col-span-2">
                    <div className="mb-2 flex items-center justify-between">
                        <p className="text-[10px] font-bold text-[#111827]">Opens this week</p>
                        <span className="rounded-full bg-[#F0FDF4] px-1.5 py-0.5 text-[8px] font-bold text-[#15803D]">+9.4%</span>
                    </div>
                    <div className="h-[100px]">
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={weekly} margin={{ top: 2, right: 0, left: 0, bottom: 0 }}>
                                <XAxis dataKey="d" tick={{ fontSize: 8, fill: "#94A3B8" }} axisLine={false} tickLine={false} />
                                <Tooltip cursor={{ fill: "#F0FDF4" }} contentStyle={{ fontSize: 10, borderRadius: 8, border: "1px solid #E5E7EB" }} />
                                <Bar dataKey="v" fill="#16A34A" radius={[3, 3, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                <div className="rounded-xl border border-[#EDF0F3] bg-white p-3 shadow-sm lg:col-span-3">
                    <p className="mb-2 text-[10px] font-bold text-[#111827]">Live Campaigns</p>
                    <div className="grid gap-1.5">
                        {campaigns.map((c) => (
                            <div key={c.name} className="flex items-center gap-2.5 rounded-lg bg-[#F8FAFC] px-2.5 py-2">
                                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-[#F0FDF4]">
                                    <c.icon className="h-3 w-3 text-[#16A34A]" />
                                </span>
                                <div className="min-w-0 flex-1">
                                    <p className="truncate text-[10px] font-semibold text-[#111827]">{c.name}</p>
                                    <p className="text-[8px] text-[#94A3B8]">{c.channel} · {c.sent} sent</p>
                                </div>
                                <span className="shrink-0 text-[9px] font-bold text-[#16A34A]">{c.rate}</span>
                                <span className="flex shrink-0 items-center gap-1 rounded-full bg-[#F0FDF4] px-1.5 py-0.5 text-[7px] font-bold text-[#15803D]">
                                    <span className="h-1 w-1 animate-pulse rounded-full bg-[#16A34A]" /> {c.status}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default EngageScreen;
